import { Query } from "@api/gql/graphql";
import { useQuery } from "@tanstack/react-query";
import { gql, GraphQLClient } from "graphql-request";

const endpoint = `${window.location.origin}/graphql`.replace("5000", "3000");
const client = new GraphQLClient(endpoint, {
  //credentials: 'include',
  //headers: () => {
  //  const token = localStorage.getItem("accessToken");
  //  return { authorization: `Bearer ${token}` };
  //},
});

const document = gql`
  query GetMaterials($co2MaterialLibrary: String!, $search: String, $skip: Int, $take: Int, $sortBy: String) {
    co2MaterialType(co2MaterialLibrary: $co2MaterialLibrary, search: $search, skip: $skip, take: $take, sortBy: $sortBy) {
      pageInfo {
        hasNextPage
      }
      totalCount
      nodes {
        co2MaterialCategoryId
        co2MaterialLibrary {
          co2MaterialLibraryId
        }
        co2MaterialLibraryId
        co2MaterialTypeId
        externalId
        description
        name
        category
        source
        sourceData
        unit
        density
        densityType
        a1A2A3
        a4
        a5
        b1
        b2
        b3
        b4
        b5
        b6
        b7
        biogenic
        c1
        c2
        c3
        c4
        d
      }
    }
  }
`;

export const useAllMaterials = (variables: { co2MaterialLibrary: string; search: string; skip?: number; take?: number; sortBy?: string; }, options?: any) => {
  return useQuery<Query>({
    ...options,
    queryKey: ["allMaterials", variables.co2MaterialLibrary, variables.search, variables.skip, variables.take, variables.sortBy],
    initialData: {},
    queryFn: async () => await client.request(document, variables),
  });
};


